import { jsxs as n, jsx as e } from "react/jsx-runtime";
import { themes as l, Highlight as L } from "prism-react-renderer";
import { useColorModeValue as S } from "@inkeep/cxkit-color-mode";
import { useCopyToClipboard as j } from "../../hooks/use-copy-to-clipboard.js";
import { useInkeepConfig as v } from "../../providers/config-provider.js";
import { dataAttr as B } from "../../utils/misc.js";
import { CustomIcon as D } from "../icons/custom-icon.js";
import { CodeblockContainer as I, CodeblockHeader as N, CodeblockHeaderLanguage as A, CodeblockCopyButton as K, CodeblockHighlighterWrapper as M, CodeblockHighlighter as V, CodeblockCode as W } from "../markdown/components.js";
const $ = l.oneLight, q = l.vsDark, R = ({ className: a = "", children: d, onCopy: h }) => {
  const o = a.replace(/^language-/, ""), r = String(d).replace(/\n$/, ""), [t, p] = j(), { baseSettings: i } = v(), m = i.theme?.syntaxHighlighter, { lightTheme: s = $, darkTheme: g = q } = m ?? {}, C = S(s, g);
  return /* @__PURE__ */ n(I, { children: [
    /* @__PURE__ */ n(N, { children: [
      /* @__PURE__ */ e(A, { children: o }),
      /* @__PURE__ */ e(
        K,
        {
          "aria-label": "Copy to clipboard",
          onClick: () => {
            p(r), h?.(o, r);
          },
          "data-copied": B(t),
          children: /* @__PURE__ */ e(D, { iconKey: t ? "codeCopied" : "codeCopy" })
        }
      )
    ] }),
    /* @__PURE__ */ e(M, { children: /* @__PURE__ */ e(
      L,
      {
        theme: C,
        code: r,
        language: o,
        prism: i.prism,
        children: ({ className: k, tokens: u, getLineProps: b, getTokenProps: f, style: y }) => /* @__PURE__ */ e(V, { className: k, children: /* @__PURE__ */ e(W, { style: y, children: u.map((c, H) => /* @__PURE__ */ e("div", { ...b({ line: c }), children: c.map((T, x) => /* @__PURE__ */ e("span", { ...f({ token: T }) }, x)) }, H)) }) })
      }
    ) })
  ] });
};
export {
  R as CodeBlock
};
